import { ConnectedRouter } from 'connected-react-router'
import React from 'react'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { BugReportingWrapper } from '@offerzen/react-utils'

import { MediaQueryProvider } from '@offerzen/pinata-shame'

import browserHistory from './core/config/browserHistory'
import configureStore from './core/config/store'
import ErrorUser from './core/containers/ErrorUser'
import CompanySubscription from './core/containers/CompanySubscription'
import SessionHistory from './core/containers/SessionHistory'
import CompanyExperienceMain from './core/Main'
import CompanyExperienceError from './core/compounds/CompanyExperienceError'
import rootSaga from './core/sagas'

const CompanyExperienceApp = () => {
  const store = configureStore()
  store.registerSaga('root', rootSaga)

  const reactQueryClient = new QueryClient()

  return (
    <QueryClientProvider client={reactQueryClient}>
      <Provider store={store}>
        <ErrorUser>
          {({ errorUser }) => (
            <BugReportingWrapper
              errorHandlingEnabled={process.env.REACT_APP_ERROR_HANDLING_ENABLED === 'true'}
              errorHandlingEndpoint={process.env.REACT_APP_ERROR_HANDLING_ENDPOINT}
              fallback={<CompanyExperienceError user={errorUser} />}
              service="company-experience"
              environment={process.env.REACT_APP_ENVIRONMENT}
              releaseId={process.env.REACT_APP_APP_VERSION}
              user={errorUser}>
              <ConnectedRouter history={browserHistory}>
                <MediaQueryProvider>
                  <SessionHistory history={browserHistory} />
                  <CompanySubscription>
                    {({ productPlan, companyDetails }) => (
                      <CompanyExperienceMain user={errorUser} companyDetails={companyDetails} productPlan={productPlan} />
                    )}
                  </CompanySubscription>
                </MediaQueryProvider>
              </ConnectedRouter>
            </BugReportingWrapper>
          )}
        </ErrorUser>
      </Provider>

      <If condition={process.env.NODE_ENV === 'development'}>
        <ReactQueryDevtools initialIsOpen={false} />
      </If>
    </QueryClientProvider>
  )
}

export default CompanyExperienceApp
